import type { KeyCreator } from '../types/api'

export interface CreatorLabel {
  text: string
  title?: string
}

/** What "Created by" shows. Missing means not recorded, never "nobody". */
export function creatorLabel(
  createdBy: KeyCreator | null | undefined,
  currentUserId: string | null | undefined,
): CreatorLabel {
  if (!createdBy) {
    return {
      text: 'Not recorded',
      title: 'Keys made before creators were recorded, or outside the portal, have none',
    }
  }
  if (currentUserId && createdBy.id.toLowerCase() === currentUserId.toLowerCase()) return { text: 'You' }
  if (createdBy.name) return { text: createdBy.name }
  return { text: 'Unknown user', title: `User id ${createdBy.id}` }
}
